export default __webpack_public_path__ + "static/media/eksport-gris.34e93670.jpg";